import { NavItem } from "./data";

/* TODO: Once pages get defined (Education and Training, Social Proof, remove and disable prefetch here as well as in other pages) */

export type PageType =
  | "services-for-families"
  | "medical-staffing"
  | "resources-for-families"
  | "resources-for-professionals";

export interface LinksItem {
  title: string;
  href: string;
  nest: string;
  pageType?: PageType;
  hideFromNavigation?: boolean;
  hideFromSitemap?: boolean;
  doNotPrefetch?: boolean;
  withLocalNav?: boolean;
}

export interface LinksObject {
  [key: string]: LinksItem;
}

const LINKS = {
  homepage: {
    title: "Homepage",
    href: "/",
    nest: "homepage",
    hideFromNavigation: true,
  },
  careAssessment: {
    title: "Care Assessment",
    href: "/care-assessment",
    nest: "careAssessment",
    hideFromNavigation: true,
  },
  careAssessmentServicesPrefilled: {
    title: "Care Assessment - Services for Families",
    href: "/care-assessment?category=services-for-families",
    nest: "careAssessment",
    hideFromNavigation: true,
    hideFromSitemap: true,
  },
  careAssessmentStaffingPrefilled: {
    title: "Care Assessment - Medical Staffing",
    href: "/care-assessment?category=medical-staffing",
    nest: "careAssessment",
    hideFromNavigation: true,
    hideFromSitemap: true,
  },
  careAssessmentScheduling: {
    title: "Care Assessment - Scheduling",
    href: "/care-assessment-scheduling",
    nest: "careAssessment/careAssessmentScheduling",
    hideFromNavigation: true,
  },
  careAssessmentThankYou: {
    title: "Care Assessment - Thank You",
    href: "/care-assessment-thank-you",
    nest: "careAssessment/careAssessmentThankYou",
    hideFromNavigation: true,
  },
  inquiryForm: {
    title: "Inquiry Form",
    href: "/contact-us",
    nest: "inquiryForm",
    hideFromNavigation: true,
  },
  inquiryFormSuccess: {
    title: "Success Page - Inquiry Form",
    href: "/contact-us-complete",
    nest: "inquiryForm/inquiryFormSuccess",
    hideFromNavigation: true,
  },
  testimonial: {
    title: "Testimonials",
    href: "/testimonial",
    nest: "testimonial",
    hideFromNavigation: true,
    doNotPrefetch: true,
  },
  aboutUs: {
    title: "About Us",
    href: "/about-us",
    pageType: "about-us",
    nest: "aboutUs",
  },
  servicesForFamilies: {
    title: "Services for Families",
    href: "/families",
    pageType: "services-for-families",
    nest: "servicesForFamilies",
  },
  homeCare: {
    title: "Home Care",
    href: "/home-care",
    pageType: "services-for-families",
    nest: "servicesForFamilies/homeCare",
  },
  liveInCare: {
    title: "Live-in and 24-hour Care",
    href: "/live-in-care",
    pageType: "services-for-families",
    nest: "servicesForFamilies/homeCare/liveInCare",
  },
  hourlyCare: {
    title: "Hourly Care",
    href: "/hourly-care",
    pageType: "services-for-families",
    nest: "servicesForFamilies/homeCare/hourlyCare",
  },
  medicationManagementService: {
    title: "Medication Management",
    href: "/medication-management",
    pageType: "services-for-families",
    nest: "servicesForFamilies/homeCare/medicationManagementService",
  },
  hospitalSitterService: {
    title: "One-on-One Hospital Sitter",
    href: "/families/sitter",
    pageType: "services-for-families",
    nest: "servicesForFamilies/hospitalSitterService",
  },
  longTermCareService: {
    title: "Long-term Care",
    href: "/long-term-care",
    pageType: "services-for-families",
    nest: "servicesForFamilies/longTermCareService",
  },
  personalConciergeService: {
    title: "Personal Concierge",
    href: "/lifestyle-assistance",
    pageType: "services-for-families",
    nest: "servicesForFamilies/longTermCareService/personalConciergeService",
  },
  postDischargeService: {
    title: "72-hour Post Discharge",
    href: "/families/care/post-discharge",
    pageType: "services-for-families",
    nest: "servicesForFamilies/longTermCareService/postDischargeService",
  },
  privateDutyMedicalCare: {
    title: "Private Duty Medical Care",
    href: "/private-duty-nurse",
    pageType: "services-for-families",
    nest: "servicesForFamilies/privateDutyMedicalCare",
  },
  skilledNursing: {
    title: "Skilled Nursing",
    href: "/skilled-nursing-services",
    pageType: "services-for-families",
    nest: "servicesForFamilies/privateDutyMedicalCare/skilledNursing",
  },
  physicalTherapy: {
    title: "Physical Therapy",
    href: "/physical-therapy",
    pageType: "services-for-families",
    nest: "servicesForFamilies/privateDutyMedicalCare/physicalTherapy",
  },
  occupationalTherapy: {
    title: "Occupational Therapy",
    href: "/occupational-therapy",
    pageType: "services-for-families",
    nest: "servicesForFamilies/privateDutyMedicalCare/occupationalTherapy",
  },
  specializedCare: {
    title: "Specialized Care",
    href: "/families/special-care",
    pageType: "services-for-families",
    nest: "servicesForFamilies/specializedCare",
  },
  hospitalToHome: {
    title: "Hospital to Home",
    href: "/hospital-to-home",
    pageType: "services-for-families",
    nest: "servicesForFamilies/specializedCare/hospitalToHome",
  },
  hospiceAndPalliativeCare: {
    title: "Hospice and Palliative Care",
    href: "/hospice-palliative-support",
    pageType: "services-for-families",
    nest: "servicesForFamilies/specializedCare/hospiceAndPalliativeCare",
  },
  diseaseSpecialties: {
    title: "Disease Specialties",
    href: "/families/disease-specialties",
    pageType: "services-for-families",
    nest: "servicesForFamilies/diseaseSpecialties",
  },
  alzheimersAndOtherDementias: {
    title: "Alzheimer's and Other Dementias",
    href: "/dementia-and-alzheimers-care",
    pageType: "services-for-families",
    nest: "servicesForFamilies/diseaseSpecialties/alzheimersAndOtherDementias",
  },
  postStroke: {
    title: "Post Stroke",
    href: "/post-stroke",
    pageType: "services-for-families",
    nest: "servicesForFamilies/diseaseSpecialties/postStroke",
  },
  parkinsonsCare: {
    title: "Parkinson's Care",
    href: "/parkinsons-caregivers",
    pageType: "services-for-families",
    nest: "servicesForFamilies/diseaseSpecialties/parkinsonsCare",
  },
  diabetes: {
    title: "Diabetes",
    href: "/diabetes-care",
    pageType: "services-for-families",
    nest: "servicesForFamilies/diseaseSpecialties/diabetes",
  },
  medicalStaffing: {
    title: "Facilities",
    href: "/staffing/medical-staffing",
    pageType: "medical-staffing",
    nest: "medicalStaffing",
  },
  longTermCareStaffing: {
    title: "Long-term Care",
    href: "/staffing/long-term-care",
    pageType: "medical-staffing",
    nest: "medicalStaffing/longTermCareStaffing",
  },
  caregivers: {
    title: "Caregivers",
    href: "/staffing/caregivers",
    pageType: "medical-staffing",
    nest: "medicalStaffing/longTermCareStaffing/caregivers",
  },
  nurses: {
    title: "Nurses",
    href: "/staffing/nursing-staffing",
    pageType: "medical-staffing",
    nest: "medicalStaffing/longTermCareStaffing/nurses",
  },
  medicationTechnicians: {
    title: "Medication Technicians",
    href: "/staffing/med-techs",
    pageType: "medical-staffing",
    nest: "medicalStaffing/longTermCareStaffing/medicationTechnicians",
  },
  therapists: {
    title: "Therapists",
    href: "/staffing/therapists",
    pageType: "medical-staffing",
    nest: "medicalStaffing/longTermCareStaffing/therapists",
  },
  frontOfficeStaff: {
    title: "Front Office Staff",
    href: "/staffing/front-office",
    pageType: "medical-staffing",
    nest: "medicalStaffing/longTermCareStaffing/frontOfficeStaff",
  },
  medicalSettings: {
    title: "Medical Settings",
    href: "/staffing/medical-settings",
    pageType: "medical-staffing",
    nest: "medicalStaffing/medicalSettings",
  },
  longTermCareFacilities: {
    title: "Long-term Care Facilities",
    href: "/staffing/long-term-facilities",
    pageType: "medical-staffing",
    nest: "medicalStaffing/medicalSettings/longTermCareFacilities",
  },
  hospital: {
    title: "Hospitals",
    href: "/staffing/hospital",
    pageType: "medical-staffing",
    nest: "medicalStaffing/medicalSettings/hospital",
  },
  hospice: {
    title: "Hospice Agencies",
    href: "/hospice-agencies",
    pageType: "medical-staffing",
    nest: "medicalStaffing/medicalSettings/hospice",
  },
  homeHealthCare: {
    title: "Home Health Agencies",
    href: "/home-health-agencies",
    pageType: "medical-staffing",
    nest: "medicalStaffing/medicalSettings/homeHealthCare",
  },
  homeHealthAgencies: {
    // Making a duplicate of homeHealthCare due to the different name
    title: "Home Health Agencies",
    href: "/home-health-agencies",
    pageType: "medical-staffing",
    nest: "medicalStaffing/medicalSettings/homeHealthAgencies",
    hideFromNavigation: true,
  },
  urgentCareClinics: {
    title: "Urgent Care Clinics",
    href: "/staffing/urgent-clinics",
    pageType: "medical-staffing",
    nest: "medicalStaffing/medicalSettings/urgentCareClinics",
  },
  extraSupportToOfferFamilies: {
    title: "Extra Support to Offer Families",
    href: "/staffing/family-support",
    pageType: "medical-staffing",
    nest: "medicalStaffing/extraSupportToOfferFamilies",
  },
  postDischargeStaffing: {
    title: "72-Hour Post-Discharge",
    href: "/staffing/post-discharge",
    pageType: "medical-staffing",
    nest: "medicalStaffing/extraSupportToOfferFamilies/postDischargeStaffing",
  },
  personalConciergeStaffing: {
    title: "Personal Concierge",
    href: "/staffing/concierge",
    pageType: "medical-staffing",
    nest: "medicalStaffing/extraSupportToOfferFamilies/personalConciergeStaffing",
  },
  medicationManagementStaffing: {
    title: "Medication Management",
    href: "/medication-administration-and-injections",
    pageType: "medical-staffing",
    nest: "medicalStaffing/extraSupportToOfferFamilies/medicationManagementStaffing",
  },
  hospitalSitterStaffing: {
    title: "1:1 Hospital Sitter",
    href: "/staffing/hospital-sitter",
    pageType: "medical-staffing",
    nest: "medicalStaffing/hospitalSitterStaffing",
  },
  howItWorks: {
    title: "How It Works",
    href: "/nursing-staffing-guide/how-it-works",
    pageType: "medical-staffing",
    nest: "medicalStaffing/howItWorks",
  },
  blog: {
    title: "Blog",
    href: "/blogs",
    nest: "resources/families/blog",
    hideFromNavigation: true,
    doNotPrefetch: true,
    hideFromSitemap: true,
    pageType: "resources-for-families",
  },
  events: {
    title: "Events",
    href: "/events",
    nest: "resources/families/events",
    hideFromNavigation: true,
    doNotPrefetch: true,
    hideFromSitemap: true,
    pageType: "resources-for-families",
  },
  classes: {
    title: "Classes",
    href: "/classes",
    nest: "resources/families/classes",
    hideFromNavigation: true,
    doNotPrefetch: true,
    hideFromSitemap: true,
    pageType: "resources-for-families",
  },
  resources: {
    title: "Resources",
    href: "/blogs", // <- No /resources even in old site
    nest: "resources",
    doNotPrefetch: true,
    hideFromSitemap: true,
    pageType: "resources-for-families",
  },
  professionals: {
    title: "For Professionals",
    href: "/blogs?type=professionals",
    nest: "resources/professionals",
    doNotPrefetch: true,
    pageType: "resources-for-professionals",
    hideFromSitemap: true,
  },
  blogProfessionals: {
    title: "Blog",
    href: "/blogs?type=professionals",
    nest: "resources/professionals/blogProfessionals",
    doNotPrefetch: true,
    pageType: "resources-for-professionals",
  },
  classesProfessionals: {
    title: "Training Classes",
    href: "/classes?type=professionals",
    nest: "resources/professionals/classesProfessionals",
    doNotPrefetch: true,
    pageType: "resources-for-professionals",
  },
  eventsProfessionals: {
    title: "Events",
    href: "/events?type=professionals",
    nest: "resources/professionals/eventsProfessionals",
    doNotPrefetch: true,
    pageType: "resources-for-professionals",
  },
  ciVR: {
    title: "CI-VR",
    href: "/ci-vr",
    nest: "resources/professionals/ciVR",
    doNotPrefetch: true,
    withLocalNav: true,
    pageType: "resources-for-professionals",
  },
  ciION: {
    title: "CI-ION",
    href: "/ci-ion",
    nest: "resources/professionals/ciION",
    doNotPrefetch: true,
    withLocalNav: true,
    pageType: "resources-for-professionals",
  },
  ciIONExternal: {
    title: "CI-ION",
    href: "https://ci-ion.com/",
    nest: "resources/professionals/ciIONExternal",
    doNotPrefetch: true,
    hideFromNavigation: true,
    pageType: "resources-for-professionals",
    hideFromSitemap: true,
  },
  ciIONExternalGetStarted: {
    title: "CI-ION - Get Started",
    href: "https://ci-ion.com/get-started",
    nest: "resources/professionals/ciIONExternalGetStarted",
    doNotPrefetch: true,
    hideFromNavigation: true,
    pageType: "resources-for-professionals",
    hideFromSitemap: true,
  },
  families: {
    title: "For Families",
    href: "/blogs?type=families",
    nest: "resources/families",
    doNotPrefetch: true,
    withLocalNav: true,
    pageType: "resources-for-families",
    hideFromSitemap: true,
  },
  blogFamilies: {
    title: "Blog",
    href: "/blogs?type=families",
    nest: "resources/families/blogFamilies",
    doNotPrefetch: true,
    pageType: "resources-for-families",
  },
  classesFamilies: {
    title: "Classes",
    href: "/classes?type=families",
    nest: "resources/families/classesFamilies",
    doNotPrefetch: true,
    pageType: "resources-for-families",
  },
  eventsFamilies: {
    title: "Events",
    href: "/events?type=families",
    nest: "resources/families/eventsFamilies",
    doNotPrefetch: true,
    pageType: "resources-for-families",
  },
  helpCenter: {
    title: "Help Center",
    href: "/help-center",
    nest: "resources/families/helpCenter",
    pageType: "resources-for-families",
  },
  paymentOptions: {
    title: "Payment Options",
    href: "/help-center/payment-options",
    nest: "resources/families/helpCenter/paymentOptions",
    hideFromNavigation: true,
    pageType: "resources-for-families",
  },
  knowledgeBase: {
    title: "Payment Options",
    href: "/help-center/knowledge-base",
    nest: "resources/families/helpCenter/knowledgeBase",
    hideFromNavigation: true,
    pageType: "resources-for-families",
  },
  careers: {
    title: "Careers",
    href: "/careers",
    nest: "careers",
    doNotPrefetch: true,
    hideFromNavigation: true,
  },
  contactUs: {
    title: "Contact Us",
    href: "/contact-us",
    nest: "contactUs",
  },
  termsOfUse: {
    title: "Terms of Use",
    href: "/terms-of-use",
    nest: "termsOfUse",
    hideFromNavigation: true,
    doNotPrefetch: true,
  },
  privacyPolicy: {
    title: "Privacy Policy",
    href: "/privacy-policy",
    nest: "privacyPolicy",
    hideFromNavigation: true,
    doNotPrefetch: true,
  },
};

export const hrefToSlugs = (href: string) => href.split("/").filter((x) => x);

// Sorts the array by order of levels (number of "/"s)
export const sortByNestingLength = (a: LinksItem, b: LinksItem) =>
  (a.nest.match(/\//g) || []).length - (b.nest.match(/\//g) || []).length;

// sorts the links object by nesting length (ascending)
export const sortedLinks: LinksItem[] = Object.values(
  LINKS as LinksObject
).sort(sortByNestingLength);

// with a sorted array, put nested items into submenus
export const linksToNavItems = (sortedLinks: LinksItem[]) => {
  const output: NavItem[] | [] = [];

  for (const linkItem of sortedLinks) {
    if (linkItem.hideFromNavigation) continue;

    // Split nest by level ("/"s)
    const nestSplits = linkItem.nest.split("/").filter((x: string) => x);

    // Sorry for the any! Can't find another solution with the time constraint.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let pointer: any = output;

    // Walk through the sorted array
    while (nestSplits.length > 0) {
      // If the levels are just one (itself), push to the pointer
      if (nestSplits.length === 1) {
        pointer.push({
          href: linkItem.href,
          displayName: linkItem.title,
          nest: linkItem.nest,
          subMenu: [],
        });
      } else {
        // If not, find the parent's index
        const newPointerIndex = pointer.findIndex((level1Item: LinksItem) =>
          (level1Item.nest || "").includes(nestSplits[0])
        );
        if (newPointerIndex > -1) {
          pointer = pointer[newPointerIndex].subMenu;
        } else {
          throw new Error("Misconfigured nest. Typo? " + linkItem.nest);
        }
      }
      // Throw away the first item
      nestSplits.shift();
    }
  }

  return output;
};

export const LINKS_NAVITEMS = linksToNavItems(sortedLinks);

/**
 * Retrieves local navigation items for a specific section.
 * @param section - The section to get navigation for ('families' or 'professionals').
 * @returns An array of navigation items with title and href properties.
 */
export const getLocalNavigation = (section: "families" | "professionals") => {
  const baseNest = `resources/${section}`;
  const relevantLinks = Object.values(LINKS).filter((link) =>
    link.nest.startsWith(baseNest)
  );

  // Define the order of navigation items for each section
  const orderMap: Record<typeof section, string[]> = {
    families: [
      "blogFamilies",
      "classesFamilies",
      "eventsFamilies",
      "helpCenter",
    ],
    professionals: [
      "blogProfessionals",
      "classesProfessionals",
      "eventsProfessionals",
      "ciVR",
      "ciION",
    ],
  };

  // Map and filter the links based on the order defined in orderMap
  return orderMap[section]
    ?.map((key) => {
      const link = relevantLinks.find((l) => l.nest.endsWith(key));
      return link ? { title: link.title, href: link.href } : null;
    })
    .filter(Boolean);
};

export const nestTypeRegex = /resources\/(professionals|families)\//;
export const dynamicCategoryRegex = /^\/blogs|\/events|\/classes/;
export const staticCategoryRegex = /^\/ci-vr|\/ci-ion|\/help-center/;

export interface BuilderLink {
  label: string;
  href: string;
  subLinks?: BuilderLink[];
  // ... any other properties from Builder.io
}

export const transformBuilderLinks = (builderLinks: BuilderLink[]) => {
  const transformedLinks: Record<string, LinksItem> = {};

  const processLink = (link: BuilderLink, parentNest: string = "") => {
    // Create a key from the href
    const key =
      link.label
        .toLowerCase()
        .replace(/ /g, "")
        .replace(/\-/g, "")
        .replace(/^\//, "")
        .replace(/\//g, "")
        .replace(/[?&=:]/g, "") +
      "-" +
      link.href
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/^\//, "")
        .replace(/\//g, "-")
        .replace(/\?type\=/g, "-");

    // Determine the nest value
    const nest = parentNest ? `${parentNest}/${key}` : key;

    // Determine pageType based on href patterns
    let pageType: PageType | undefined;
    if (link.href.includes("families")) pageType = "services-for-families";
    else if (link.href.includes("/staffing")) pageType = "medical-staffing";
    else if (link.href.includes("/resources")) {
      pageType = link.href.includes("professionals")
        ? "resources-for-professionals"
        : "resources-for-families";
    }

    // Create the LinksItem
    transformedLinks[key] = {
      title: link.label,
      href: link.href,
      nest,
      pageType,
      hideFromNavigation: false,
      hideFromSitemap: false,
      doNotPrefetch: false,
    };

    // Process subLinks recursively
    if (link.subLinks?.length) {
      link.subLinks.forEach((subLink) => {
        processLink(subLink, nest);
      });
    }
  };

  // Process all top-level links
  builderLinks.forEach((link) => {
    processLink(link);
  });

  return transformedLinks;
};

export const linksObjectToNavItems = (links: LinksObject) => {
  return linksToNavItems(Object.values(links).sort(sortByNestingLength));
};

export default LINKS;
